'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import * as Type from './mutation-type'
Vue.use(Vuex)




const actions = {
  showToggle: ({
    commit
  }) => {
    commit('SHOW_TOGGLE')
  },
  layout: ({
    commit
  }) => {
    commit("LAYOUT")
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js